import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { IFileIngestionHistory, IFileMetadataMessage, IFileMetadataStats, IServerSettings, IServiceError } from '../models/index';
import { AuthenticationService } from './authentication.service';
import { SettingsService } from './settings.service';


@Injectable()
export class FileUploadService {

  private action: string;
  private fileManagementApiUrl: string;
  private settings: IServerSettings;


  constructor (private http: HttpClient, private settingsService: SettingsService, private authService: AuthenticationService) {
  }

  public getAppGridDefaults() {
    return this.http.get('../assets/griddefaults.json');
  }

  public getMockFileHistory() {
    return this.http.get('../assets/mock/db_file_history.json');
  }

  fetchUploadedFileHistory(customerId: string): Observable<{} | IFileIngestionHistory[] | IServiceError> {

    this.settings = this.settingsService.getSettings();
    this.fileManagementApiUrl = this.settings.ApiGatewayUrl;
    this.action = `fms/v1/UploadInventory`;

      const headers = this.authService.setHeader(false, true);

    return this.http.get<IFileIngestionHistory>(`${ this.fileManagementApiUrl }/${ this.action }/${ customerId }`, { headers: headers }).pipe(
      catchError(err => this.handleHttpError(err))
    );

  }

  getFileMetadataStatistics(fileMetadataId: number, customerId: number): Observable<{} | IFileMetadataStats[] | IServiceError> {

    this.action = 'fms/v1/UploadDetails';
    this.settings = this.settingsService.getSettings();
    this.fileManagementApiUrl = this.settings.ApiGatewayUrl;

    const headers = this.authService.setHeader();

    if (!isNaN(fileMetadataId)) {
      return this.http.get<IFileMetadataStats>(`${ this.fileManagementApiUrl }/${ this.action }/${ fileMetadataId }/${ customerId }`, { headers: headers })
        .pipe(
          catchError(err => this.handleHttpError(err))
        );
    } else {
      const dataError = new IServiceError();
      dataError.friendlyMessage = `Url parameter was altered with the non-numeric data`;

      // return an observable of an IServiceError object with a user friendly error message
      return throwError(dataError);
    }
  }

  getFileOutcome(fileMetadataGuid: string) {

    this.action = 'fms/v1/FileManagement/GetFileOutcome';
    this.settings = this.settingsService.getSettings();
    this.fileManagementApiUrl = this.settings.ApiGatewayUrl;

    const headers = this.authService.setHeader(false, true);

    return this.http.get<any>(`${ this.fileManagementApiUrl }/${ this.action }?fileMetadataGuid=${ fileMetadataGuid }`, { headers: headers }).pipe(
      map(response => response.data)
    );
  }

    getLogDataFile(fileMetadataGuid: string, customerId: string, reportFormat: string, reportFilename: string) {

    this.action = 'fms/v1/FileManagement/ImportLog';

      const headers = this.authService.setHeader(false);

      // headers = headers.set('applicationVariantName', '');
      // headers = headers.set('applicationVariantId', '');

        return this.http.get(`${this.fileManagementApiUrl}/${this.action}?fileMetadataGuid=${ fileMetadataGuid }&customerId=${ customerId }&reportFormat=${ reportFormat }&reportFilename=${ reportFilename }`, { responseType: 'blob' as 'json', headers: headers }).pipe(
      map(response => {
        return response;
      })
    );
  }

  getFileMetadataMessages(fileMetadataId: number, customerId: number): Observable<{} | IFileMetadataMessage[] | IServiceError> {

    this.action = 'fms/v1/FileMetadataMessage/getFileMetadataMessages';
    this.settings = this.settingsService.getSettings();
    this.fileManagementApiUrl = this.settings.ApiGatewayUrl;

    const headers = this.authService.setHeader();

    if (!isNaN(fileMetadataId)) {
      return this.http.get<IFileMetadataMessage[]>(`${ this.fileManagementApiUrl }/${ this.action }/${ fileMetadataId }/${ customerId }`, { headers: headers })
        .pipe(
          catchError(err => this.handleHttpError(err))
        );
    } else {
      const dataError = new IServiceError();
      dataError.friendlyMessage = `Url parameter was altered with the non-numeric data.`;

      // return an observable of an IServiceError object with a user friendly error message
      return throwError(dataError);
    }
  }

  private handleHttpError(error: HttpErrorResponse): Observable<IServiceError> {
       if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${ error.status }, ` +
        `body was: ${ error.error }`);
    }

    const dataError = new IServiceError();
    dataError.errorNumber = error.error ? error.error.number : '';
    dataError.message = error.message;
    dataError.friendlyMessage = `Oops.. Something's wrong..please try again later.`;
    dataError.errorMessage = error.error ? error.error.message : '';
    dataError.errorStatus = error.status;
    dataError.url = error.url;

    // return an observable of an IServiceError object with a user friendly error message
    return throwError(dataError);
  }
}
